module.exports = "/_next/static/images/43f79326f98cde1a14f1c413f87487ef-hero-cultural-hack-xs-2x.jpg.webp";